import { ValidateEmail, warn } from '@swivl-mono/helpers';
import { Button, ButtonColor, ButtonSize, Input } from '@swivl-mono/ui';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import AccountModel from '../../Models/Account/AccountModel';
import { LocalStorageHelper } from '../../Models/LocalStorage/LocalStorageHelper';
import { NavBar } from '../../Models/NavBar/NavBar.Model';
import Logo from './Assets/SwivlLogo.png';
import "./Login.View.scss";

export function LoginView() {
  const { loginError } = AccountModel.useState()
  const [queryParams, setQueryParams] = useSearchParams();
  const [username, setUsername] = useState(queryParams?.get("email") ?? "");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    LocalStorageHelper.removeItem("botId");
    NavBar.set(null, <NavBar.Component.Logo />, null);
  }, [])

  const loginClicked = () => {
    var validEmail = ValidateEmail(username.toLowerCase());
    if (validEmail === false) {
      setErrorMsg("Please enter a valid email");
      return;
    }
    setIsLoading(true);
    setErrorMsg("");
    AccountModel.logIn(username.toLowerCase(), password, navigate, true).catch((error: Error) => {
      warn("ERRRRR", error)
      if (typeof error === "string") {
        setErrorMsg(error);
      } else if (error.message) {
        setErrorMsg(error.message);
      } else {
        setErrorMsg("Error Logging In");
        warn("Error Logging In", error);
      }
      setIsLoading(false);
    })
  }

  useEffect(() => {
    if (loginError) {
      setErrorMsg(loginError);
      setIsLoading(false);
    } else if (errorMsg.length > 0) {
      setErrorMsg("");
    }
  }, [loginError])
  return (
    <div className="SignUpView flex flex-col items-center">
      <img src={Logo} alt="Swivl Logo" className="w-1/2 mx-auto mb-8" />
      <div className="container mx-auto">

        <div className="loginContent  mx-auto">
          <h1 className="text-lg">Login</h1>
          <h4>Email</h4>
          <Input
            size={Input.Size.Large}
            value={username}
            name="username"
            onSet={setUsername}
            enableAutoComplete={true}
            onReturnPressed={() => {
              if (username.length > 1 && password.length > 1) {
                loginClicked();
              } else {
                //focus on password 
                var passwordInput = document.getElementById("passwordInput");
                if (passwordInput) {
                  passwordInput.focus();
                }
              }
            }}
          />
          <h4>Password</h4>
          <Input
            id="passwordInput"
            size={Input.Size.Large}
            value={password}
            name="password"
            onSet={setPassword}
            enableAutoComplete={true}
            type={Input.Type.Password}
            onReturnPressed={loginClicked}
          />
          <div className="errorMsg text-red-500 mb-5">{errorMsg}</div>
          <div className="mb-5">
            <Button
              fullWidth
              onClick={loginClicked}
              loading={isLoading}
              color={ButtonColor.ORANGE}
              size={ButtonSize.LARGE}
            >
              LOG IN
            </Button>
          </div>

          <div className="loginContent  mx-auto text-center">
            <Link className="w-full forgotText text-center" to={"/forgot-password?email=" + encodeURIComponent(username)}>Forgot?</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
